import React, { useState, useRef, useEffect } from 'react';
import styles from './CustomSelect.module.css';

const CustomSelect = ({ options, selected, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find(option => option.value === selected);

  return (
    <div className={styles['custom-select']} ref={selectRef}>
      <div
        className={`${styles['select-selected']} ${!selectedOption ? styles.placeholder : ''}`}
        onClick={handleSelectClick}
      >
        {selectedOption ? selectedOption.label : placeholder}
        <span className={`${styles['select-arrow']} ${isOpen ? styles.open : ''}`}></span>
      </div>
      {isOpen && (
        <div className={styles['select-items']}>
          {options.map((option) => (
            <div
              key={option.value}
              className={styles['select-item']}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
